import { BlogPostContent } from '@/types/blog';
import { intro } from './sections/intro';
import { goldenSnippet } from './sections/golden-snippet';
import { emotionalerEisberg } from './sections/emotionaler-eisberg';
import { katalysatorMethode } from './sections/katalysator-methode';
import { fuerWen } from './sections/fuer-wen';
import { fazit } from './sections/fazit';
import { referenzen } from './sections/referenzen';
import { faq } from './sections/faq';

export const content: BlogPostContent = {
  sections: [
    intro,
    goldenSnippet,
    emotionalerEisberg,
    katalysatorMethode,
    fuerWen,
    fazit,
    referenzen,
    faq
  ]
};
